export const TREE_CONSTANTS = {
  DROP_FLASH_DURATION: 300,
  DEFAULT_INDENT: 16,
} as const;
